import $api from '../../utils/api.js'


const state = () => ({
    user_agent:[],
    selected_bonus_agent:[],
    bonus: {
        total: 0,
        per_page: 2,
        from: 1,
        to: 0,
        current_page: 1
    },
    sorting: {
        num:10,
        search: '',
        agent_id:'',
        start_date: '',
        end_date: '',
        tier:'',
        offset: 4,
        placeholder:'Search Admin'
    },
    formbonus:{
        agent_id:'',
        bonus:'',
        claim_date:'',
    },
    errors:[],

    bonus_agent:[]
})

const mutations = {
    ASSIGN_DATA_BONUS_AGENT(state, payload){
        state.bonus_agent = payload
    },
    ASSIGN_DATA(state, payload) {
        state.bonus = payload
    },
    ASSIGN_USER_AGENT(state, payload) {
        state.user_agent = payload
    },
    ASSIGN_SELECTED_BONUS_AGENT(state, payload) {
        state.selected_bonus_agent = payload
    },
    CLEAR_FORM(state) {
        state.formbonus = {
            user_id:'',
            bonus:'',
            claim_date:'',
        },
        state.selected_bonus_agent = []
        state.errors = []
    },
    CLEAR_BONUS(state){
        state.bonus = {
            total: 0,
            per_page: 2,
            from: 1,
            to: 0,
            current_page: 1
        }
    },
    SET_ERRORS(state, payload) {
        state.errors = payload
    },
}

const actions = {
    getBonus({ commit, state }) {
        var page = state.sorting.search ? 1 : state.bonus.current_page

        return new Promise((resolve) => {
            $api.get(`bonus?page=${page}&paginate=${state.sorting.num}&search=${state.sorting.search}&agent_id=${state.sorting.agent_id}&tier=${state.sorting.tier}&start_date=${state.sorting.start_date}&end_date=${state.sorting.end_date}`)
            .then((response) => {
                commit('ASSIGN_DATA', response.data)
                resolve(response.data)
            })
        })
    },
    getUserAgent({ commit }) {
        return new Promise((resolve,reject) => {
            $api.get(`select/user-agent`)
            .then((response) => {
                commit('ASSIGN_USER_AGENT', response.data)
                resolve(response.data)
            }) .catch((error) => {
                reject(error)
            })
        })
    },
    getSelectedBonusAgent({ commit }, payload) {
        return new Promise((resolve,reject) => {
            $api.get(`selected-bonus-agent/${payload}`)
            .then((response) => {
                commit('ASSIGN_SELECTED_BONUS_AGENT', response.data)
                resolve(response.data)
            }) .catch((error) => {
                reject(error)
            })
        })
    },
    claimBonusAgent({state }, payload) {
        return new Promise((resolve,reject) => {
            $api.post(`claim-bonus-agent/${state.formbonus.user_id.id}`, payload)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    deleteBonus({ dispatch }, payload) {
        return new Promise((resolve,reject) => {
            $api.delete(`bonus/${payload}`)
            .then(() => {
                dispatch('getBonus').then(() => resolve())
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
  
    //AGENT
    getBonusAgent({ commit }) {
        return new Promise((resolve,reject) => {
            $api.get(`bonus-agent`)
            .then((response) => {
                commit('ASSIGN_DATA_BONUS_AGENT', response.data)
                resolve(response.data)
            }) .catch((error) => {
                reject(error)
            })
        })
    },

}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}